export const FLAG_GETTING_MAINTENANCE_TASKS = 'FLAG_GETTING_MAINTENANCE_TASKS';
export const GET_MAINTENANCE_TASKS = 'GET_MAINTENANCE_TASKS';
export const CLEAR_MAINTENANCE_TASKS = 'CLEAR_MAINTENANCE_TASKS';
export const FLAG_MAINTENANCE_TASK_ACTIVITY = 'FLAG_MAINTENANCE_TASK_ACTIVITY';
export const GET_MAINTENANCE_TASK = 'GET_MAINTENANCE_TASK';
export const CLEAR_MAINTENANCE_TASK = 'CLEAR_MAINTENANCE_TASK';
